var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBifamiliare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 584,
    height: 606,
    viewBox: "0 0 584 606",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M284.745 389.407L139.633 305.668V106.281L284.745 190.02V389.407Z",
    fill: "#B6CEFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M386.262 365.252L139.633 222.936V210.355L386.262 352.672V365.252Z",
    fill: "#0047CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M386.262 462.77L139.633 320.453V305.656L386.262 447.973V462.77Z",
    fill: "#0047CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M284.745 182.143L139.633 98.4141V106.282L284.745 190.02V182.153V182.143Z",
    fill: "#0047CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M386.259 447.976L284.742 389.398V306.668L386.259 365.246V447.976Z",
    fill: "#B6CEFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M370.314 438.78L300.695 398.613V333.156L370.314 373.323V438.78Z",
    fill: "#003EB3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M320.428 411.507L317.391 410.034V342.77L320.428 344.242V411.507Z",
    fill: "#0047CC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M337.021 419.533L333.984 418.06V352.398L337.021 353.871V419.533Z",
    fill: "#0047CC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M353.615 430.589L350.578 429.116V361.852L353.615 363.324V430.589Z",
    fill: "#0047CC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M268.814 380.201L244.289 366.053V304.5L268.814 318.648V380.201Z",
    fill: "#0047CC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M386.259 352.664L284.742 258.332V294.086L386.259 352.664Z",
    fill: "#0047CC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M264.884 350.429L248.211 340.804V311.59L264.884 321.215V350.419V350.429Z",
    fill: "#003EB3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M268.814 260.128L244.289 245.98V191.426L268.814 205.574V260.128Z",
    fill: "#0047CC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M264.884 237.356L248.211 227.731V198.527L264.884 208.152V237.356Z",
    fill: "#F7F8FB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M264.884 377.933L248.211 368.308V346.492L264.884 356.117V377.933Z",
    fill: "#003EB3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M169.271 311.858L148.922 300.117V245.562L169.271 257.304V311.858Z",
    fill: "#0047CC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M166.083 270.164L152.117 262.106V251.094L166.083 259.151V270.164Z",
    fill: "#F7F8FB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M166.083 306.337L152.117 298.28V266.23L166.083 274.288V306.337Z",
    fill: "#F7F8FB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M195.091 326.765L174.742 315.023V260.469L195.091 272.21V326.765Z",
    fill: "#0047CC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M191.903 285.07L177.938 277.013V266L191.903 274.057V285.07Z",
    fill: "#F7F8FB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M191.903 321.232L177.938 313.175V281.125L191.903 289.182V321.232Z",
    fill: "#F7F8FB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M220.92 341.671L200.57 329.929V275.375L220.92 287.117V341.671Z",
    fill: "#0047CC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M217.731 299.965L203.766 291.907V280.895L217.731 288.952V299.965Z",
    fill: "#F7F8FB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M217.731 336.138L203.766 328.081V296.031L217.731 304.089V336.138Z",
    fill: "#F7F8FB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M169.271 202.69L148.922 190.949V136.395L169.271 148.136V202.69Z",
    fill: "#0047CC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M166.083 160.996L152.117 152.938V141.926L166.083 149.983V160.996Z",
    fill: "#F7F8FB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M166.083 197.17L152.117 189.112V157.062L166.083 165.12V197.17Z",
    fill: "#F7F8FB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M195.091 217.597L174.742 205.855V151.301L195.091 163.042V217.597Z",
    fill: "#0047CC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M191.903 175.902L177.938 167.845V156.832L191.903 164.889V175.902Z",
    fill: "#F7F8FB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M191.903 212.076L177.938 204.018V171.969L191.903 180.026V212.076Z",
    fill: "#F7F8FB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M220.92 232.503L200.57 220.761V166.207L220.92 177.949V232.503Z",
    fill: "#0047CC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M217.731 190.797L203.766 182.739V171.727L217.731 179.784V190.797Z",
    fill: "#F7F8FB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M217.731 226.97L203.766 218.913V186.863L217.731 194.921V226.97Z",
    fill: "#F7F8FB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M139.633 98.4132L284.745 13.4766V182.142L139.633 98.4132Z",
    fill: "#003EB3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M531.37 281.516L386.258 365.254V352.664L531.37 268.926V281.506V281.516Z",
    fill: "#002466"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M531.37 379.031L386.258 462.77V447.973L531.37 364.234V379.031Z",
    fill: "#002466"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M531.37 364.246L386.258 447.984V365.254L531.37 281.516V364.246Z",
    fill: "#5C93F8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M469.967 378.583L447.68 391.443V350.907L469.967 338.047V378.573V378.583Z",
    fill: "#002466"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M466.474 376.917L451.18 385.743V353.693L466.474 344.867V376.917Z",
    fill: "#DDEFFF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M436.537 397.872L414.25 410.732V370.196L436.537 357.336V397.872Z",
    fill: "#002466"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M433.044 396.206L417.75 405.032V372.982L433.044 364.156V396.206Z",
    fill: "#DDEFFF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M503.381 359.292L481.094 372.152V331.625L503.381 318.766V359.292Z",
    fill: "#002466"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M499.896 357.624L484.602 366.45V334.4L499.896 325.574V357.624Z",
    fill: "#DDEFFF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M429.864 98.4132L284.742 13.4766V182.142L429.854 98.4032L429.864 98.4132Z",
    fill: "#002466"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M429.862 174.592L284.75 258.331V190.008L429.862 106.27V174.592Z",
    fill: "#5C93F8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M429.862 98.4141L284.75 182.153V190.02L429.862 106.282V98.4141Z",
    fill: "#002466"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M335.022 215.429L312.734 228.289V187.762L335.022 174.902V215.429Z",
    fill: "#002466"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M331.529 213.761L316.234 222.587V190.537L331.529 181.711V213.761Z",
    fill: "#DDEFFF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M401.873 176.849L379.586 189.709V149.172L401.873 136.312V176.839V176.849Z",
    fill: "#002466"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M398.38 175.182L383.086 184.009V151.959L398.38 143.133V175.182Z",
    fill: "#DDEFFF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M531.376 268.914L429.859 174.582V210.346L531.376 268.924V268.914Z",
    fill: "#0047CC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M284.742 258.331L429.854 174.582L531.371 268.914L386.259 352.662L284.742 258.331Z",
    fill: "#003EB3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M199.676 378.388L163.742 357.521L175.27 350.871L211.204 371.738L199.676 378.388Z",
    fill: "#85AFFB"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M159.918 438.001L123.984 417.134L131.966 412.531L167.9 433.398L159.918 438.001Z",
    fill: "#85AFFB"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M159.938 447.15L124.014 426.282L123.984 417.137L159.918 438.004L159.948 447.15H159.938Z",
    fill: "#0047CC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M167.871 424.245L131.938 403.378L139.899 398.785L175.833 419.652L167.871 424.245Z",
    fill: "#85AFFB"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M167.901 433.388L131.967 412.521L131.938 403.375L167.871 424.242L167.901 433.388Z",
    fill: "#0047CC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M175.838 419.65L139.905 398.783L139.875 389.617L175.808 410.484L175.838 419.65Z",
    fill: "#0047CC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M175.808 410.476L139.875 389.608L147.847 385.016L183.78 405.883L175.818 410.476H175.808Z",
    fill: "#85AFFB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M183.754 396.737L147.82 375.87L155.792 371.277L191.726 392.145L183.754 396.737Z",
    fill: "#85AFFB"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M183.784 405.884L147.85 385.017L147.82 375.871L183.754 396.738L183.784 405.884Z",
    fill: "#0047CC"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M191.699 382.99L155.766 362.122L163.747 357.52L199.681 378.387L191.699 382.99Z",
    fill: "#85AFFB"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M261.92 344.359L262.05 390.128L199.803 424.144L167.926 442.545L159.944 447.148L159.914 438.002L167.896 433.4L167.866 424.254L175.838 419.661L175.808 410.496L183.77 405.903L183.74 396.757L191.712 392.164L191.682 383.019L199.664 378.416L261.91 344.399L261.92 344.359Z",
    fill: "#5C93F8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M191.713 392.134L155.78 371.267L155.75 362.121L191.683 382.988L191.713 392.134Z",
    fill: "#0047CC"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M222.347 338.048L186.414 317.181L197.942 310.531L233.876 331.398L222.347 338.048Z",
    fill: "#85AFFB"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M182.59 397.665L146.656 376.798L154.638 372.195L190.572 393.063L182.59 397.665Z",
    fill: "#85AFFB"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M182.612 406.81L146.678 385.943L146.648 376.797L182.582 397.664L182.612 406.81Z",
    fill: "#0047CC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M190.543 383.905L154.609 363.038L162.571 358.445L198.505 379.313L190.543 383.905Z",
    fill: "#85AFFB"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M190.573 393.06L154.639 372.193L154.609 363.047L190.543 383.914L190.573 393.06Z",
    fill: "#0047CC"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M198.518 379.314L162.585 358.447L162.555 349.281L198.488 370.148L198.518 379.314Z",
    fill: "#0047CC"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M198.488 370.148L162.555 349.28L170.527 344.688L206.46 365.555L198.498 370.148H198.488Z",
    fill: "#85AFFB"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M206.426 356.398L170.492 335.53L178.464 330.938L214.397 351.805L206.426 356.398Z",
    fill: "#85AFFB"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M206.456 365.544L170.522 344.677L170.492 335.531L206.426 356.398L206.456 365.544Z",
    fill: "#0047CC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M214.371 342.65L178.438 321.782L186.419 317.18L222.353 338.047L214.371 342.65Z",
    fill: "#85AFFB"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M261.793 313.965L261.923 359.733L222.483 383.815L190.606 402.216L182.624 406.819L182.594 397.673L190.576 393.071L190.546 383.925L198.518 379.332L198.488 370.167L206.449 365.574L206.419 356.428L214.391 351.835L214.361 342.69L222.343 338.087L261.783 314.005L261.793 313.965Z",
    fill: "#5C93F8"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M214.393 351.798L178.46 330.931L178.43 321.785L214.363 342.652L214.393 351.798Z",
    fill: "#0047CC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M262.441 269.228L226.508 248.36L238.036 241.711L273.969 262.578L262.441 269.228Z",
    fill: "#85AFFB"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M222.683 328.845L186.75 307.978L194.732 303.375L230.665 324.242L222.683 328.845Z",
    fill: "#85AFFB"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M222.713 338.001L186.78 317.134L186.75 307.988L222.683 328.856L222.713 338.001Z",
    fill: "#0047CC"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M230.637 315.097L194.703 294.23L202.665 289.637L238.598 310.504L230.637 315.097Z",
    fill: "#85AFFB"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M230.666 324.239L194.733 303.372L194.703 294.227L230.637 315.094L230.666 324.239Z",
    fill: "#0047CC"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M238.604 310.494L202.671 289.627L202.641 280.461L238.574 301.328L238.604 310.494Z",
    fill: "#0047CC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M238.574 301.327L202.641 280.46L210.613 275.867L246.546 296.734L238.584 301.327H238.574Z",
    fill: "#85AFFB"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M246.519 287.577L210.586 266.71L218.558 262.117L254.491 282.984L246.519 287.577Z",
    fill: "#85AFFB"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M246.549 296.736L210.616 275.868L210.586 266.723L246.519 287.59L246.549 296.736Z",
    fill: "#0047CC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M254.465 273.829L218.531 252.962L226.513 248.359L262.447 269.227L254.465 273.829Z",
    fill: "#85AFFB"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M273.967 262.578L274.097 308.346L273.448 380.862L262.05 390.138L222.71 338.01L222.68 328.864L230.662 324.261L230.632 315.116L238.603 310.523L238.573 301.357L246.535 296.764L246.505 287.619L254.477 283.026L254.447 273.88L262.429 269.278L273.957 262.628L273.967 262.578Z",
    fill: "#5C93F8"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M254.495 282.986L218.561 262.118L218.531 252.973L254.465 273.84L254.495 282.986Z",
    fill: "#0047CC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBifamiliare);
export default __webpack_public_path__ + "static/media/bifamiliare.2e4b5afbc26732eb61c233f8966ada78.svg";
export { ForwardRef as ReactComponent };